import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';


import { AutoritaIndipendente } from '../../../../common/models/tipologiche/autorita-indipendente';

export class FascicoloAutoritaIndipendentiRegolatorie extends FascicoloFull {
  autoritaIndipendente: AutoritaIndipendente;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
